<template>
  <v-dialog
    v-model="dialog"
    max-width="900px">
    <v-card class="privilegios">
      <v-card-title>
        <span class="text-h5">{{ $t("view.seguridad.privilegiosPerfiles.titulo.label") }}</span>
        <v-spacer />
        <v-text-field
          v-model="view.elem.datatable.search"
          append-icon="mdi-magnify"
          :label="$t('view.commons.search')"
          single-line
          dense
          hide-details
          class="mr-8"
          @change="load" />
        <v-btn
          fab
          small
          color="primary"
          class="btn_tippy"
          elevation="0"
          :title="$t('view.commons.close')"
          @click="dialog = false">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="hidden-sm-and-down">{{ perfil }}</v-card-subtitle>
      <v-card-text>
        <v-layout
          row
          wrap
          class="mx-0 my-0">
          <v-flex
            xs12
            class="overflow">
            <v-data-table
              ref="dataTable"
              item-key="permiso"
              class="privilegios dataTable"
              sort-by="check"
              :sort-desc.sync="view.elem.datatable.sortdesc"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :search="view.elem.datatable.search"
              :must-sort="true"
              :items-per-page="-1"
              :options.sync="options"
              hide-default-footer>
              <template #item.check="{ item }">
                <v-btn
                  :disabled="!$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                  fab
                  dark
                  x-small
                  elevation="0"
                  style="width: 25px; height: 25px"
                  :loading="item.busy"
                  :color="item.check ? 'primary' : 'green'"
                  :title="item.check ? $t('view.commons.remove') : $t('view.commons.add')"
                  class="btn_tippy"
                  @click="privilegeAddOrRemove(item)">
                  <v-icon>{{ item.check ? "clear" : "add" }}</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import perfilAPI from "@/services/seguridad/perfil"; /** *******************************/
import { handleResponse } from "@/helpers/http-response-handler";
import tippy from "tippy.js";

export default {
  name: "PrivilegiosModal"
  , data() {
    return {
      dialog: false
      , privileges: []
      , perfil: ""
      , options: {}
      , view: {
        action: { submit: { busy: false } }
        , elem: {
          datatable: {
            data: []
            , search: ""
            , sortdesc: true
            , headers: [
              { text: this.$t("view.seguridad.privilegiosPerfiles.privilegio.th"), align: "left", sortable: true, class: "permiso", value: "permiso" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: true, class: "accion", value: "check" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    async load() {
      this.view.elem.datatable.data = this.privileges;
      this.view.elem.datatable.total = Number(this.privileges.length);
    }
    , async loadPrivileges(clave, nombrePerfil) {
      const respuesta = await perfilAPI.getPrivileges(clave);
      this.privileges = respuesta.data.results.permisosPerfil;
      this.view.elem.datatable.search = "";
      this.view.elem.datatable.sortdesc = true;
      this.privileges.forEach((item) => {
        this.$set(item, "busy", false);
      });
      this.perfil = `Perfil: ${nombrePerfil}`;
      this.dialog = true;
      this.load();
    }
    , async privilegeAddOrRemove(privilegio) {
      let response;
      privilegio.busy = true;
      if (privilegio.check) {
        response = await perfilAPI.removePrivilege(privilegio);
      } else {
        response = await perfilAPI.addPrivilege(privilegio);
      }
      if (handleResponse(response, this.$t("view.seguridad.privilegiosPerfiles.errors"))) {
        privilegio.check = !privilegio.check;
      }
      setTimeout(() => {
        privilegio.busy = false;
        this.privileges = response.data.results.permisosPerfil;
        this.load();
      }, 200);
    }
  }
};
</script>

<style>
.privilegios .overflow {
  overflow-y: auto;
  max-height: 600px;
}
@media (max-height: 850px) {
  .privilegios .overflow {
    max-height: 400px !important;
  }
}
@media (max-height: 650px) {
  .privilegios .overflow {
    max-height: 300px !important;
  }
}
@media (max-height: 510px) {
  .privilegios .overflow {
    max-height: auto;
    overflow-y: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/perfil/PrivilegiosModal.vue